"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.toshaio = void 0;
var cowllector = '0xd529b1894491a0a26B18939274ae8ede93E81dbA';
// const zeroAddress = '0x0000000000000000000000000000000000000000';
// const treasuryMultisig = '0x0f9602B7E7146a9BaE16dB948281BebDb7C2D095';
exports.toshaio = {
    strategyOwner: '0x5B96bbAca98D777cb736dd89A519015315E00D02',
    vaultOwner: '0x8B157c6DAeC439b447337A2F08ef055F5182B817',
    keeper: '0x10aee6B5594942433e7Fc2783598c979B030eF3D',
    rewarder: cowllector,
    treasurer: '0x3Eb7fB70C03eC4AEEC97C6C6C1B59B014600b7F7',
    launchpoolOwner: cowllector,
    rewardPool: '0xE70604eCC12e625dd09a9FDd6CD0DfE1F2913dee',
    treasury: '0xd9F2Da642FAA1307e4F70a5E3aC31b9bfe920eAF',
    beefyFeeRecipient: '0x32C82EE8Fca98ce5114D2060c5715AEc714152FB',
    multicall: '0x2F24F54C07Af317a174B907027c5AAA4144390d1',
    bifiMaxiStrategy: '0xF2f8c64691E0Be88535388675C01a58E8557D0E8',
};
